import { StdResponse, request } from "@/global/config/request";

export function getDeviceList(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/device-list`, {
        params: {
            ...params,
        }
    })
}